import { useState, useEffect } from "react";

export function useDebounce(value, delay, minLength = 0) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (value.length >= minLength || value.length === 0) {
                setDebouncedValue(value);
            }
        }, delay);

        return () => clearTimeout(handler);
    }, [value, delay, minLength]);

    return debouncedValue;
}
